import React, { useState } from 'react';
import axios from '../../../library/axios';
import { MySwal } from '../../../library/swal';
import { Button } from 'react-bootstrap';
import { getSlug, } from "../../../../src/config/routes/guards/slug";
import { notifyApiError } from '../../../helpers/notifyApiError';

const ListPokjaComp = (props) => {
  // console.log(props);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const handleHapus = (id) => {
    // console.log(id);
    MySwal.fire({
      title: 'Apa anda yakin menghapus data ini?',
      text: 'Anda tidak akan dapat mengembalikan data ini!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ya, Hapus Data!',
      cancelButtonText: 'Batal',
    }).then((result) => {
      if (result.isConfirmed) {
        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
          },
        };

        axios
          .delete(`/pokja-detail/delete/${id}`, config)
          .then((res) => {
            // console.log(res);
            // return false;
            if (res.status === 200) {
              MySwal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Hapus Anggota Pokja Berhasil!',
              });
              // return false
              setTimeout(() => {
                props.close();
                props.fetch();
              }, 3000);
            }
          })
          .catch((err) => {
            if (err !== '') {
            notifyApiError(err, { context: 'components/moleculs/pokja/modules.handleHapus' });
              // err({ err: err?.response?.data || err });
            }
          });
      }
    });
  };

  return (
    <>
      {/*begin::Tables Widget 9*/}
      <div className="card mb-5 mb-xl-8">
        {/*begin::Body*/}
        <div className="card-body py-3">
          {/*begin::Table container*/}
          <div className="table-responsive">
            {/*begin::Table*/}
            <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
              {/*begin::Table head*/}
              <thead>
                <tr className="fw-bolder text-muted">
                  <th className="min-w-150px">Nama Anggota</th>
                  <th className="min-w-100px">Aksi</th>
                </tr>
              </thead>
              {/*end::Table head*/}
              {/*begin::Table body*/}
              <tbody>
                {props?.pokja?.pokja_details.map((row, i) => (
                  <tr>
                    <td>
                      <div className="d-flex align-items-center">
                        <div className="d-flex justify-content-start flex-column">
                          {i + 1}
                          {'. '}
                          {row.user?.namaLengkap}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="d-flex justify-content flex-shrink-0">
                        <Button
                          disabled={disabled}
                          variant="danger"
                          size="sm"
                          onClick={() => handleHapus(row?.id)}
                        >
                          {loading === true ? 'Mohon Tunggu..' : 'Hapus'}
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
              {/*end::Table body*/}
            </table>
            {/*end::Table*/}
          </div>
          {/*end::Table container*/}
        </div>
        {/*begin::Body*/}
      </div>
      {/*end::Tables Widget 9*/}
    </>
  );
};

export default ListPokjaComp;
